import { alpha, Box, Paper, Typography } from "@mui/material";
import type { BiAgentMessage as BiAgentMessageType } from "../../../../../../api/types/biAgentTypes";

interface BiAgentMessageProps {
  message: Pick<BiAgentMessageType, "role" | "content">;
}

export const BiAgentMessage = ({ message }: BiAgentMessageProps) => {
  const isUser = message.role === "user";

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: isUser ? "flex-end" : "flex-start",
      }}
    >
      <Paper
        elevation={0}
        sx={(t) => ({
          p: 1,
          maxWidth: "85%",
          bgcolor: isUser ? alpha(t.palette.primary.main, 0.08) : "transparent",
          borderRadius: 2,
        })}
      >
        <Typography sx={{ whiteSpace: "pre-wrap" }}>{message.content}</Typography>
      </Paper>
    </Box>
  );
};
